import React from "react";
import { consultantAvailability } from "../../../../../Utils/constants";

export default function Sidebar({ details }) {
  return (
    <div className="flex rounded-lg flex-col space-y-4  py-4 px-8 bg-white h-min">
      <span className="flex flex-row items-center space-x-2">
        {" "}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            stroke-linejoin="round"
            d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
          />
          <path
            strokeLinecap="round"
            stroke-linejoin="round"
            d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
          />
        </svg>
        <span>
          {details?.location.length > 0
            ? details.location
            : "No Location Provided"}
        </span>
      </span>
      <span className="flex flex-row items-center space-x-2">
        {" "}
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.4489 20.4495H16.8929V14.8804C16.8929 13.5525 16.8691 11.8429 15.0434 11.8429C13.1912 11.8429 12.9078 13.2899 12.9078 14.7838V20.4491H9.35188V8.99697H12.7656V10.562H12.8134C13.155 9.97787 13.6487 9.49732 14.2419 9.17154C14.835 8.84577 15.5054 8.68697 16.1817 8.71206C19.7859 8.71206 20.4504 11.0828 20.4504 14.167L20.4489 20.4495ZM5.33938 7.43162C4.19966 7.43181 3.27557 6.508 3.27538 5.36828C3.27519 4.22856 4.19891 3.30447 5.33863 3.30428C6.47835 3.304 7.40244 4.22781 7.40263 5.36753C7.40273 5.91484 7.18541 6.43978 6.79848 6.82687C6.41155 7.21396 5.8867 7.4315 5.33938 7.43162ZM7.11744 20.4496H3.55766V8.99697H7.11735V20.4495L7.11744 20.4496ZM22.2217 0.00174674H1.77079C0.804224 -0.00912826 0.0115684 0.765153 -0.000244141 1.73172V22.2679C0.0111934 23.235 0.803756 24.01 1.77069 23.9999H22.2217C23.1907 24.0119 23.9863 23.2368 23.9998 22.2679V1.73012C23.986 0.761684 23.1902 -0.0125033 22.2217 0.00015299"
            fill="#787878"
          />
        </svg>
        {details?.linkedin ? (
          <a
            className="text-blue-500"
            href={
              details?.linkedin && details?.linkedin.split(":")[0] === "https"
                ? details?.linkedin
                : "https://" + details?.linkedin
            }
          >
            {details?.linkedin}
          </a>
        ) : (
          <span>No Linkedin</span>
        )}
      </span>
      <div className="flex flex-row space-x-2 items-center">
        <span className="text-xl"> Availability :</span>
        <span className="flex flex-row space-x-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            className="w-6 h-6 mr-2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          {details?.availability_hours}
        </span>
      </div>
      <span className="my-4 text-xl">Skills</span>

      <div className="flex flex-row flex-wrap w-full">
        {details.skills.map((skill, idx) => (
          <span
            style={{
              background: "rgba(35, 75, 135, 0.05)",
              borderRadius: "4px",
              padding: "2px 10px 2px 10px",
              margin: "0.3rem",
            }}
            key={idx}
          >
            {skill}
          </span>
        ))}
      </div>
    </div>
  );
}
